'use client';
import Script from 'next/script';

import { Column, Padded } from '@/components/layout/column';

export default function TermlyPage({ dataId }: { dataId: string }) {
  return (
    <Column>
      <Script src='https://app.termly.io/embed-policy.min.js' async />
      <Padded className='flex flex-col gap-8 py-8'>
        <div
          data-id={dataId}
          data-type='iframe'
          // @ts-ignore
          name='termly-embed'
        />
      </Padded>
    </Column>
  );
}
